import { UPGRADES } from "./constants";

// Each achievement: id, title, description, icon key, and check(state)->boolean.
export const ACHIEVEMENTS = [
  {
    id: "first_click",
    title: "First Spin",
    description: "Click the wheel for the first time.",
    icon: "spark",
    check: (s) => s.wheelsBuilt >= 1,
  },
  {
    id: "hundred_clicks",
    title: "Active Wheel",
    description: "Click 100 times.",
    icon: "click",
    check: (s) => s.wheelsBuilt >= 100,
  },
  {
    id: "thousand_clicks",
    title: "Craftsman Hands",
    description: "Click 1,000 times.",
    icon: "click",
    check: (s) => s.wheelsBuilt >= 1000,
  },
  {
    id: "ten_thousand_clicks",
    title: "Rolling Master",
    description: "Click 10,000 times.",
    icon: "click",
    check: (s) => s.wheelsBuilt >= 10000,
  },
  {
    id: "first_upgrade",
    title: "First Investment",
    description: "Buy your first upgrade.",
    icon: "shop",
    check: (s) => Object.values(s.upgrades || {}).some((c) => c >= 1),
  },
  {
    id: "five_eras",
    title: "Time Traveler",
    description: "Unlock 5 different eras.",
    icon: "era",
    check: (s) => Object.keys(s.seenEras || {}).length >= 5,
  },
  {
    id: "all_eras",
    title: "Full History",
    description: "Unlock all 12 eras.",
    icon: "trophy",
    check: (s) => Object.keys(s.seenEras || {}).length >= UPGRADES.length,
  },
  {
    id: "berries_1k",
    title: "First Fortune",
    description: "Accumulate 1,000 Berries.",
    icon: "berry",
    check: (s) => (s.highestBerries || s.berries || 0) >= 1000,
  },
  {
    id: "berries_1m",
    title: "Millionaire",
    description: "Reach 1M Berries at once.",
    icon: "berry",
    check: (s) => (s.highestBerries || s.berries || 0) >= 1e6,
  },
  {
    id: "berries_1b",
    title: "Wheel Tycoon",
    description: "Reach 1B Berries.",
    icon: "berry",
    check: (s) => (s.highestBerries || s.berries || 0) >= 1e9,
  },
  {
    id: "f1_unlock",
    title: "High Speed",
    description: "Unlock the Formula 1 era.",
    icon: "era",
    check: (s) => (s.seenEras || {}).f1 === true,
  },
  {
    id: "space_unlock",
    title: "Stellar Wheel",
    description: "Take the wheel to space.",
    icon: "trophy",
    check: (s) => (s.seenEras || {}).space === true,
  },
  {
    id: "hundred_upgrades",
    title: "Collector",
    description: "Buy 100 upgrades total.",
    icon: "shop",
    check: (s) => Object.values(s.upgrades || {}).reduce((a, b) => a + b, 0) >= 100,
  },
];

// Given current state, return the list of achievement objects merged with an
// `unlocked` boolean.
export const evaluateAchievements = (state) =>
  ACHIEVEMENTS.map((a) => ({
    ...a,
    unlocked: a.check(state),
  }));
